import type { ReactNode } from 'react';
import {
  BiSolidCheckCircle,
  BiSolidError,
  BiSolidInfoCircle,
  BiSolidXCircle,
} from 'react-icons/bi';
import './Banner.css';

export type BannerTone = 'danger' | 'warning' | 'success' | 'info';

interface BannerProps {
  tone: BannerTone;
  children: ReactNode;
  /** Blocking/critical banners should assert (`role="alert"`); informational ones use
   * `role="status"` so screen readers don't interrupt — 10-design-system.md §5 "Live regions". */
  assertive?: boolean;
  action?: ReactNode;
}

export function Banner({ tone, children, assertive, action }: BannerProps) {
  return (
    <div
      className={`fa-banner fa-banner--${tone}`}
      role={assertive ? 'alert' : 'status'}
      aria-live={assertive ? 'assertive' : 'polite'}
    >
      <span aria-hidden="true" className="fa-banner__icon">
        {tone === 'danger' && <BiSolidXCircle />}
        {tone === 'warning' && <BiSolidError />}
        {tone === 'success' && <BiSolidCheckCircle />}
        {tone === 'info' && <BiSolidInfoCircle />}
      </span>
      <div className="fa-banner__body">{children}</div>
      {action && <div className="fa-banner__action">{action}</div>}
    </div>
  );
}
